import React from "react"
import "./Tooltip.css"

const Tooltip = ({ tooltip }) => {
  if (!tooltip.visible || !tooltip.name) return null

  return (
    <div
      className="map-tooltip"
      style={{
        left: Math.min(tooltip.x + 10, window.innerWidth - 120),
        top: Math.min(tooltip.y + 10, window.innerHeight - 40),
      }}
    >
      {tooltip.name}
    </div>
  )
}

export default Tooltip
